import { render } from "./ErrProhibited.vue?vue&type=template&id=08a05c2e&scoped=true"
import script from "./ErrProhibited.vue?vue&type=script&lang=js"
export * from "./ErrProhibited.vue?vue&type=script&lang=js"

import "./ErrProhibited.vue?vue&type=style&index=0&id=08a05c2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a05c2e"]])

export default __exports__